import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';
import { channelPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

import { ITvDescriptions } from '~/src/components/TariffCard';

import IncludesList from './includesList';

import { AccServiceBlock, AccServiceTitle, ServiceBlock, ServiceTitle } from '~/src/components/TariffCard/styled';

interface ITvProps {
    isAccordion: boolean,
    withBg: boolean,
    bgColor: string,
    colorText: string,
    isOpen?: boolean,
    onToggle?: () => void,
    totalChannels: number,
    tvDescriptions: ITvDescriptions[],
    openPopup: () => void,
}

const channelText = getPluralize(channelPluralize);

const TvBlock = ({ isAccordion, withBg, bgColor, colorText, isOpen, onToggle, totalChannels, tvDescriptions, openPopup }: ITvProps): JSX.Element => {
    return (isAccordion && tvDescriptions.length
        ? <AccServiceBlock
            withBg={withBg}
            bgColor={bgColor}
            isClosed={!isOpen}
            defaultOpen={isOpen}
            open={isOpen}
            toggle={onToggle}
            data-test='acc-includes'
            title={
                <AccServiceTitle data-test='block-title'>
                    {totalChannels}&nbsp;{channelText(totalChannels)}
                </AccServiceTitle>
            }
        >
            <IncludesList
                tvDescriptions={tvDescriptions}
                openPopup={openPopup}
            />
        </AccServiceBlock>
        : <ServiceBlock data-test='includes'>
            <ServiceTitle bgColor={bgColor} colorText={colorText} withBg={withBg} data-test='block-title'>
                {totalChannels}&nbsp;{channelText(totalChannels)}
            </ServiceTitle>
            {!!tvDescriptions.length && <IncludesList
                tvDescriptions={tvDescriptions}
                openPopup={openPopup}
            />}
        </ServiceBlock>
    );
};

export default TvBlock;
